import { Box, Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import { LoadingOutlined } from '@ant-design/icons';
import { message } from "antd";
import { useState } from "react";
import { Email, Send } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const EnterEmail = () => {
    const [email, setEmail] = useState();
    const [sending, setSending] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate()

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/forgot-password/otp-send-mail`,{
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({email: email}),
        });

        const responseData = await response.json();
        if(response.status === 250) {
            messageApi.open({
                type: 'success',
                content: `${responseData.message}`,
                style: {
                  marginTop: '15vh',
                },
            });
            setTimeout(() => {
                navigate('/enter-otp');
            }, 1000);
        } else if(response.status === 404){
          messageApi.open({
            type: 'error',
            content: `${responseData.error_message}`,
            style: {
              marginTop: '15vh',
            },
        });
        } else if(response.status === 500) {
            messageApi.open({
                type: 'error',
                content: `${responseData.error_message}`,
                style: {
                  marginTop: '15vh',
                },
            });
            
        } 
        setSending(false);
    }

  return (
    <Box sx={{display: "flex" ,justifyContent: "center", padding: "50px", fontWeight: "500px"}}>
      {contextHolder}
      <Paper elevation={0} sx={{width: "400px", backgroundColor: "#ffff", margin: "100px"}}>
        <Grid className="form-title" container spacing={1}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5, fontWeight: "400", fontFamily: "Roboto Mono"}}>Enter Email</Typography> </Grid>
          <Grid item> <Email sx={{width: 40, height: 40}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={3} sx={{margin: "30px"}}>
            <TextField
              variant="standard"
              name="email"
              label="Email"
              size="small"
              value={email}
              onChange={handleEmailChange}
            />
            <Grid container className="form-input-row">
              <Grid item>
               <Button variant="contained" color="success" size="medium" disableElevation type="submit" endIcon={sending ? <LoadingOutlined /> : <Send />}>Send OTP</Button>
              </Grid>
            </Grid>
            </Stack>
        </form>
      </Paper>
    </Box>
  )
}

export default EnterEmail;
